import { useMemo } from "react";
import FormatDateTime from "../Functions/FormatDate";
import { useLanguage } from "../Translations/LenguageContext";

const StatusCell = ({ severity }) => {
    const statusMap = {
        "0": {
            className: "active",
            text: "Success",
        },
        "1": {
            className: "warning",
            text: "Warning",
        },
        "2": {
            className: "error",
            text: "Error",
        },
    };

    const currentStatus = statusMap[severity] || {
        className: "active",
        text: "Active",
    };

    return (
        <div className="custom_cell_status">
            <span className={`status_dot ${currentStatus.className}`}></span>
            <span className="status_text">{currentStatus.text}</span>
        </div>
    );
};
const LogsTable = ({ data }) => {
    const {t} = useLanguage()
    const headers = useMemo(() => {
        return ["ID", "Status", t.log, t.created_at];
    }, []);

    return (
        <div className="custom_table_container fade-in">
            <table className="custom_table">
                <thead className="custom_table_head">
                    <tr className="custom_table_row">
                        {headers.map((header, index) => (
                            <th key={index} className="custom_table_th">
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className="custom_table_body">
                    {data.length > 0 ? (
                        data.map((item, rowIndex) => (
                            <tr key={item.id || rowIndex} className="custom_table_row">
                                <td className="custom_table_td td_user">
                                    {item.id}
                                </td>
                                <td className="custom_table_td td_orgs">
                                    <StatusCell severity={item.severity} />
                                </td>
                                <td className="custom_table_td td_orgs">
                                    {item.message}
                                </td>
                                <td className="custom_table_td td_orgs">
                                    {FormatDateTime(item.created_at)}
                                </td>

                            </tr>
                        ))
                    ) : (
                        <tr className="custom_table_row_empty">
                            <td colSpan={headers.length} className="custom_table_td_empty">
                                No logs found matching your criteria.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default LogsTable;